import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'task_title',
    viewPath: props.viewPath,
  })

  let title = useDataValue({
    context: 'task',
    path: 'title',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.title = title
    })
    setFlowTo(normalizePath(props.viewPath, '../Edit'))
  }
}
